import React, { useState } from 'react';

import PropTypes from 'prop-types';

import Accordion, { AccordionItem } from '@adsk/alloy-react-accordion';

import ReferencePickerBlockGroup from '../blocks/ReferencePickerBlockGroup';
import ReferencePickerBlockTitle from '../blocks/ReferencePickerBlockTitle';
import getPluginKey from '../helpers/getPluginKey';

export const AccordionVariant = ({
  groupData,
  allowRemoveLinkedEntity,
  setDataToConfirmRemoving,
  updateEntitiesInCache,
  onReferenceClickAnalytics,
  sourceEntityId,
  sourceEntityDomain,
  sourceEntityType,
}) => {
  const [pluginCollapsed, setPluginCollapsed] = useState({});

  return (
    <Accordion multiExpand={true} data-testid="reference-picker-accordion">
      {groupData.map(({ plugin, entityCache, relationships }) => {
        const { PluralText } = plugin;
        const pluginKey = getPluginKey(plugin);

        return (
          <AccordionItem
            expanded={!pluginCollapsed[pluginKey]}
            onExpand={() =>
              setPluginCollapsed((prev) => ({
                ...prev,
                [pluginKey]: !prev[pluginKey],
              }))
            }
            key={pluginKey}
            style={{
              margin: '0',
            }}
            title={
              <ReferencePickerBlockTitle isAccordionVariant>
                <PluralText /> <>({relationships.length})</>
              </ReferencePickerBlockTitle>
            }
          >
            <ReferencePickerBlockGroup
              plugin={plugin}
              relationships={relationships}
              entitiesCache={entityCache}
              allowRemoveLinkedEntity={allowRemoveLinkedEntity}
              setDataToConfirmRemoving={setDataToConfirmRemoving}
              updateEntitiesInCache={updateEntitiesInCache}
              onReferenceClickAnalytics={onReferenceClickAnalytics}
              sourceEntityId={sourceEntityId}
              sourceEntityDomain={sourceEntityDomain}
              sourceEntityType={sourceEntityType}
              isAccordionVariant
            />
          </AccordionItem>
        );
      })}
    </Accordion>
  );
};

AccordionVariant.propTypes = {
  /**
   *  Data by groups to be displayed
   */
  groupData: PropTypes.arrayOf(
    PropTypes.shape({
      plugin: PropTypes.shape({
        PluralText: PropTypes.func,
      }),
      entityCache: PropTypes.object,
      relationships: PropTypes.array.isRequired,
    }),
  ).isRequired,
  /**
   *  Allow remove linked entity
   */
  allowRemoveLinkedEntity: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.func,
  ]),
  /**
   *  Set data to confirm removing
   */
  setDataToConfirmRemoving: PropTypes.func,
  /**
   *  Update entities in cache
   */
  updateEntitiesInCache: PropTypes.func,
  /**
   *  On reference click analytics
   */
  onReferenceClickAnalytics: PropTypes.func,
  /**
   *  Source entity id
   */
  sourceEntityId: PropTypes.string.isRequired,
  /**
   *  Source entity domain
   */
  sourceEntityDomain: PropTypes.string.isRequired,
  /**
   *  Source entity type
   */
  sourceEntityType: PropTypes.string.isRequired,
};
